export default __webpack_public_path__ + "static/media/publisher2.0777de23.png";